import React, { useState } from "react";

import { compact } from "lodash/fp";

import type { SxProps } from "@mui/material";
import styled from "@mui/material/styles/styled";

import useResponsiveView from "@app/common/hooks/useResponsiveView";

import TooltipWrapper from "@rui/TooltipWrapper";

import {
  NoteCardAccordion,
  NoteCardAccordionDetails,
  NoteCardAccordionSummary,
} from "./styles";

interface NoteCardProps {
  header: React.ReactNode;
  children: React.ReactNode;
  forceExpand: boolean;
  isEditing: boolean;
  wrapperProps?: {
    disabled?: boolean;
    disabledTooltip?: string;
    sx?: SxProps;
  };
}

const StyledTooltip = styled(TooltipWrapper)(({ theme }) => ({
  "&:not(:first-of-type)": {
    "& .MuiAccordion-root.Mui-expanded:first-of-type": {
      marginTop: theme.spacing(2),
    },
  },
}));

const NoteCard = ({
  children,
  forceExpand,
  header,
  wrapperProps,
  isEditing,
}: NoteCardProps) => {
  const [expanded, setExpanded] = useState(true);

  const { inDesktopView } = useResponsiveView();

  const toggleExpanded = () => setExpanded((e) => !e);

  const className = compact([
    isEditing ? "editing" : undefined,
    wrapperProps?.disabled ? "disabled" : undefined,
  ]).join(" ");

  const isExpanded = inDesktopView || forceExpand || expanded;

  return (
    <StyledTooltip
      wrapperSx={{ width: "100%" }}
      followCursor
      title={wrapperProps?.disabledTooltip}
      show={wrapperProps?.disabled}
    >
      <NoteCardAccordion
        expanded={isExpanded}
        sx={wrapperProps?.sx}
        className={className}
      >
        <NoteCardAccordionSummary onClick={toggleExpanded}>
          {header}
        </NoteCardAccordionSummary>
        <NoteCardAccordionDetails>{children}</NoteCardAccordionDetails>
      </NoteCardAccordion>
    </StyledTooltip>
  );
};

export default NoteCard;
